import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { QueryKeys } from '../keys';
import { request } from '../request';
import { userSchema } from './schemas';

export const userQueryOptions = queryOptions({
  queryKey: QueryKeys.user,
  queryFn: async () => {
    const response = await request('/user');

    const { data: user } = apiResourceSchema(userSchema).parse(response);

    return user;
  },
  staleTime: 60 * 1000,
  gcTime: Infinity,
});

export const useUser = () => useSuspenseQuery(userQueryOptions);

export const useIsImpersonating = () =>
  useSuspenseQuery({
    ...userQueryOptions,
    select: ({ impersonatingAdminId }) => !!impersonatingAdminId,
  }).data;
